export default __webpack_public_path__ + "static/media/016-rocket.4094f6b8.svg";